import React from 'react';
const Plus = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg
    width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7 1V13M13 7H1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);


export default Plus;